export default __webpack_public_path__ + "asset/img/quote-right~1b95e070.png";